import { useLocation } from 'react-router-dom';
import { isInternalFlowPath } from '../../lib/portalAudience';
import {
  requestCode,
  requestCodeInternal,
  forgotPassword,
  forgotPasswordInternal,
} from './authSlice';

// Derives the forgot-password flow shape (portal vs internal) from the URL
// path. The three forgot-password containers — ForgotPassword, ConfirmCode,
// ResetPassword — call this hook to pick the right thunks and the right
// next-step paths. The legacy `?from=client|staff` query parameter is
// IGNORED entirely; only the URL path determines which flow runs (FR-014,
// FR-015).
//
// /forgot-password           → portal flow
// /forgot-password/internal  → internal flow
// /confirm-code              → portal flow
// /confirm-code/internal     → internal flow
// /reset-password            → portal flow
// /reset-password/internal   → internal flow
export const useForgotPasswordFlow = () => {
  const location = useLocation();
  const isInternal = isInternalFlowPath(location.pathname);

  if (isInternal) {
    return {
      isInternal: true,
      requestCodeThunk: requestCodeInternal,
      forgotPasswordThunk: forgotPasswordInternal,
      forgotPasswordPath: '/forgot-password/internal',
      confirmCodePath: '/confirm-code/internal',
      resetPasswordPath: '/reset-password/internal',
      signInPath: '/team-portal',
      accent: '#6b63f5',
      accentHover: '#7c75f7',
    };
  }

  return {
    isInternal: false,
    requestCodeThunk: requestCode,
    forgotPasswordThunk: forgotPassword,
    forgotPasswordPath: '/forgot-password',
    confirmCodePath: '/confirm-code',
    resetPasswordPath: '/reset-password',
    signInPath: '/',
    accent: '#c9a96e',
    accentHover: '#d4b47a',
  };
};
